export default {
  // set coupon
  SET_COUPON_START: 'SET_COUPON_START',
  SET_COUPON_SUCCESS: 'SET_COUPON_SUCCESS',
  SET_COUPON_FAIL: 'SET_COUPON_FAIL',
  // clear coupon
  CLEAR_COUPON_START: 'CLEAR_COUPON_START',
  CLEAR_COUPON_SUCCESS: 'CLEAR_COUPON_SUCCESS',
  CLEAR_COUPON_FAIL: 'CLEAR_COUPON_FAIL',
};
